import { Card, Tag } from 'antd';
import { PageHeader } from '@ant-design/pro-components';
import Createduserstable from 'components/Createduserstable/Createduserstable';
import Userprinthistory from 'components/Userprinthistory/Userprinthistory';
import Usertransactiontable from 'components/Usertransactiontable/Usertransactiontable';
import UserLoginActivity from 'components/LoginActivity/index';
import { observer } from 'mobx-react';
import React, { useContext, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { rootContext } from 'stores';

import './Userdetails.scss';

const Userdetails: React.FC = observer(() => {
  const id = useParams().id as string;
  const navigate = useNavigate();
  const {
    UsersStore: {
      removeUserDetails,
      state: {
        data: { userDetail }
      }
    }
  } = useContext(rootContext);

  useEffect(() => {
    return () => {
      removeUserDetails();
    };
  }, [removeUserDetails]);

  return (
    <div className="UserdetailsStyles">
      <div className="cardWrapeer">
        <Card>
          <PageHeader
            title={
              <div className="header">
                <h3>{userDetail.user_details?.email}</h3>
                {userDetail.user_details?.email !==
                  userDetail.user_details?.username && (
                    <p>{userDetail.user_details?.username}</p>
                  )}
              </div>
            }
            extra={<Tag>{userDetail.user_details?.userType}</Tag>}
            onBack={() => navigate(-1)}
          />

          <Usertransactiontable id={id} />

          <Userprinthistory id={id} />

          {userDetail.user_details?.userType &&
            ['distributor', 'employee', 'admin', 'super admin'].includes(
              userDetail.user_details?.userType
            ) && <Createduserstable id={id} />}

          <div style={{ marginTop: '40px' }}>
            <UserLoginActivity id={id} />
          </div>
        </Card>
      </div>
    </div>
  );
});

export default Userdetails;
